import { Col, Row } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $ColContainer = styled(Col)`
  margin-top: ${spacing(20)};
`;

export const $RowContainer = styled(Row)`
  display: flex;
  align-items: stretch;
`;

export const $ColSvgItem = styled(Col)`
  padding-left: unset;
  padding-right: unset;
  svg {
    width: ${spacing(16)} !important;
    height: ${spacing(16)} !important;
  }
`;

export const $IconSvgItem = styled('div')`
  display: block;
  width: ${spacing(10)};
  height: ${spacing(10)};
`;
